
import {
  ArrayInput,
  Create,
  email,
  ReferenceInput,
  regex,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  useRedirect,
} from "react-admin";
import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import { AddressInputs } from "../../components/address-inputs.component";
import { Col, Row } from "../../components/grid.component";
import { Text } from "../../components/typography.component";
import { formatCPForCNPJ, formatPhone, normalizeDocumentForApi } from "../../utils/mask.util";
import { regexs } from "../../utils/regexs.util";

export const UserCreate = (props: any) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [createdUserId, setCreatedUserId] = useState<string | null>(null);
  const redirect = useRedirect();
  

  const handleSuccess = (data: any) => {
    setCreatedUserId(data.id);
    setOpenDialog(true);
  };

  const handleCreateLicense = () => {
    setOpenDialog(false);
    localStorage.setItem('selectedUserId', createdUserId || '');
    redirect('create', 'licenses');
  };

  const handleClose = () => {
    setOpenDialog(false);
    redirect('list', 'users');
  };

  return (
    <>
      <Create
        transform={(data: any) => ({
          ...data,
          registration: normalizeDocumentForApi(data.registration),
        })}
        {...props}
        mutationOptions={{ onSuccess: handleSuccess }}
      >
        <SimpleForm>
        <Text variant="subtitle1" display="block">
          Dados básicos
        </Text>
        <Row spacing={4}>
          <Col sm={3}>
            <TextInput fullWidth source="name" label="Nome" validate={required()} />
          </Col>
          <Col sm={3}>
            <TextInput fullWidth source="email" label="E-mail" validate={email()} />
          </Col>
          <Col sm={3}>
            <TextInput fullWidth source="username" label="Usuário" validate={required()} />
          </Col>
          <Col sm={2}>
            <TextInput
              fullWidth
              source="registration"
              defaultValue=""
              parse={(value: string) => value?.toUpperCase()}
              format={(value: string) => formatCPForCNPJ(value)}
              validate={[required(), regex(regexs.CPJ_AND_CNPJ_REGEX, "CPF ou CNPJ Inválido")]}
              label="CPF/CNPJ"
            />
          </Col>
        </Row>
        <Row spacing={2}>
          <Col sm={3}>
            <TextInput source="phone" fullWidth label="Telefone" parse={(value: string) => formatPhone(value)} />
          </Col>
        </Row>
        <Row spacing={1}></Row>
        <Text variant="subtitle1" display="block">
          Emails secundários
        </Text>
        <Row spacing={1}>
          <Col sm={12}>
            <ArrayInput source="emails" label={null} style={{ marginTop: 0, marginBottom: 16 }}>
              <SimpleFormIterator disableReordering>
                <TextInput source="email" label="Email" validate={email()} />
              </SimpleFormIterator>
            </ArrayInput>
          </Col>
        </Row>
        <Text variant="subtitle1" display="block">
          Telefones
        </Text>
        <Row spacing={1}>
          <Col sm={12}>
            <ArrayInput source="phones" label={null} style={{ marginTop: 0, marginBottom: 16 }}>
              <SimpleFormIterator disableReordering>
                <TextInput source="phone" label="Telefone" parse={(value: string) => formatPhone(value)} />
              </SimpleFormIterator>
            </ArrayInput>
          </Col>
        </Row>
        <AddressInputs />
        <Row spacing={1}>
          <Col sm={12}>
            <ReferenceInput label="Empresa" reference="companies" source="company.id" perPage={1000}>
              <SelectInput optionText="name" fullWidth />
            </ReferenceInput>
          </Col>
        </Row>
        <Row spacing={1}>
          <Col sm={12}>
            <TextInput 
              label="Observações" 
              source="observations" 
              fullWidth 
              multiline
              rows={4}
            />
          </Col>
        </Row>
      </SimpleForm>
    </Create>

    <Dialog
      open={openDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Usuário criado com sucesso
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Deseja incluir uma nova licença para este usuário?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Não
        </Button>
        <Button onClick={handleCreateLicense} color="primary" autoFocus>
          Sim
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};
